import { DataTableEmptyCell } from "@bcc/components/data-table";
import { formatPrice } from "@bcc/lib/utils";
import { useVendorContext } from "@client-shared/providers/vendor";
import type { PurchaseOrder } from "@shared/types";
import { CellContext } from "@tanstack/react-table";

export const OrderValueCell = (props: CellContext<PurchaseOrder, unknown>) => {
  const [{ currencyObject }] = useVendorContext();
  const orderTotal = props.row.original.orderTotal;

  if (!orderTotal) return <DataTableEmptyCell />;

  return <span className="text-sm">{formatPrice(orderTotal, currencyObject?.symbol, currencyObject?.iso)}</span>;
};
